import StarterKit from "@tiptap/starter-kit";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import TextStyle from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import { Color } from "@tiptap/extension-color";
import Link from "@tiptap/extension-link";
import CustomListItem from "./CustomNotes/CustomListItem";
import Placeholder from "@tiptap/extension-placeholder";
import { LinkShortcut } from "./CustomNotes/addLinkShortcut";
import { YoutubeLinkHandler } from "./CustomNotes/YouTubeLinkHandler";
import {
    getHierarchicalIndexes,
    TableOfContents,
} from "@tiptap/extension-table-of-contents";
// import { ParagraphIndent } from "./extensions/ParagraphIndent";
import { NewLineBelow } from "./extensions/NewLineBelow";

const tipTapExtensions = [
    CustomListItem,
    // ParagraphIndent, //*A bit buggy
    StarterKit.configure({
        listItem: false,
    }),
    TaskItem.configure({
        nested: true,
    }),
    TaskList,
    Underline,
    Color,
    TextStyle,
    Link,
    Placeholder,
    LinkShortcut,
    YoutubeLinkHandler,
    TableOfContents,
    NewLineBelow,
];

export { tipTapExtensions };
